import { render, staticRenderFns } from "./groups-view.vue?vue&type=template&id=6fc1141a&"
import script from "./groups-view.vue?vue&type=script&lang=js&"
export * from "./groups-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports